import { Card } from 'antd';
import React, { FC } from 'react';
import { EmptyState } from '../empty_state/EmptyState';
import WorkOrderTable from '../WorkOrderTable';
import { ShowAllFooterWorkOrders } from '../WorkOrderTable/TableFooter';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { withCurrentUser } from '../../hooks/withCurrentUser';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

const ASSET_ASSOCIATED_ACTIVE_WORK_ORDERS_TARGET_COLLECTION =
	'FETCH_DATA_FROM_SERVER_assetAssociatedActiveWorkOrders';

const AssetActiveWorkOrdersCard: FC<any> = ({ assetId, currentUser }): React.ReactElement => {
	return (
		<Card title="Active Work Orders" key={assetId}>
			<WorkOrderTable
				CustomHeader={() => <></>}
				preAppliedFilters={{
					assetIds: [assetId],
					displayStatuses: [
						WORK_ORDER_DISPLAY_STATUSES.pending,
						WORK_ORDER_DISPLAY_STATUSES.deferred,
						WORK_ORDER_DISPLAY_STATUSES.open,
						WORK_ORDER_DISPLAY_STATUSES.inProgress,
						WORK_ORDER_DISPLAY_STATUSES.hold,
					],
					[getWorkOrderArchivalKey(currentUser)]: false,
				}}
				tableStyle={{
					display: 'flex',
					flexDirection: 'column',
					cursor: 'pointer',
					userSelect: 'none',
					marginTop: '-10px',
					marginBottom: '-9px',
				}}
				initialPagination={{ current: 1, pageSize: 3 }}
				initialSorting={{
					sort_by: 'woPriorityAndIsAssetDown',
					order: 'ascend',
				}}
				targetCollectionName={ASSET_ASSOCIATED_ACTIVE_WORK_ORDERS_TARGET_COLLECTION}
				renderEmptyState={() => (
					<EmptyState
						graphic={
							<img
								alt="There aren't any active work orders for this asset."
								style={{ marginBottom: 8 }}
								src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
							/>
						}
						headline={'No news is good news.'}
						body={
							<div style={{ textAlign: 'center' }}>
								<div style={{ maxWidth: 440, marginBottom: 16 }}>
									There aren't any active work orders for this asset.
								</div>
							</div>
						}
					/>
				)}
				backText="Back to asset"
				openMoreInDefault
				ignoreRefreshCounts
				CustomFooter={ShowAllFooterWorkOrders}
			/>
		</Card>
	);
};

export default withCurrentUser(AssetActiveWorkOrdersCard);
